import styled from 'styled-components';
import LocationTime from '@rsos/components/capstone/DataCards/DataCardLocation/LocationTime';
import CallSource from '@rsos/components/capstone/Location/CallSource';
import { Box, Text } from '@rsos/components/capstone/base';
import useHasLocationsToRender from '@rsos/hooks/useHasLocationsToRender';
import { formatPhoneWithDashes } from '@rsos/utils';

export const StyledCallerID = styled(Text).attrs({
  color: 'panePrimaryText',
  fontWeight: 'bold',
})``;

interface Props {
  isInternational: boolean;
  callerID: string;
  timestamp: number;
  source: string;
}

export const ExpandedHeaderData = ({
  isInternational,
  callerID,
  timestamp,
  source,
}: Props) => {
  const hasLocationsToRender = useHasLocationsToRender();

  // `66` includes a 16px padding bottom. `auto` for outbound SMS
  const eventPaneHeaderHeight = hasLocationsToRender ? 66 : 'auto';

  return (
    <Box height={eventPaneHeaderHeight}>
      <StyledCallerID data-name="event-pane-caller-id">
        {isInternational ? callerID : formatPhoneWithDashes(callerID)}
      </StyledCallerID>
      {hasLocationsToRender && (
        <>
          <Box paddingTop={1} paddingBottom={1}>
            <LocationTime
              size="xsmall"
              timeAgoTextSize="small"
              timeBoxTextSize="xsmall"
              timeStamp={timestamp}
              noPadding
            />
          </Box>
          <CallSource source={source} />
        </>
      )}
    </Box>
  );
};
